import { ReactElement, useState } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { TabsNavigation, TabsNavigationItemData } from "client/Components";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { Base64FileUriUploadWithMetadataAndAttributionModel } from "client/Misc/commonTypes";
import styles from "./FocalPointDialogContent.module.less";
import { FocalPointPreviewSection } from "./FocalPointPreviewSection";
import { FocalPointEditorSection } from "./FocalPointEditorSection";
import { FocalPoint, FocalPointOptions } from "./FocalPointDialog";

export type FocalPointDialogContentProps = {
	uri: string;
	value: FocalPoint;
	onChange: (focalPoint: FocalPoint) => void;
	onImageChange: (image: Base64FileUriUploadWithMetadataAndAttributionModel) => void;
	options: FocalPointOptions;
	onIsBusyChange: (isBusy: boolean) => void;
};

export const FocalPointDialogContent = (props: FocalPointDialogContentProps): ReactElement => {
	const {
		uri,
		value,
		onChange,
		onImageChange,
		onIsBusyChange,
		options
	} = props;

	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);
	const [activeTabId, setActiveTabId] = useState<TabId>("editor");

	return (
		<div className={styles.root}>
			<div className={styles.tabNavigation}>
				<TabsNavigation
					trackingId="focal-point-tabs"
					items={tabsData}
					onChange={setActiveTabId}
					value={activeTabId}
				/>
			</div>
			<div className={styles.content}>
				{(!isResponsive || activeTabId === "editor") && (
					<div className={styles.editorSectionContainer}>
						<FocalPointEditorSection
							uri={uri}
							focalPoint={value}
							onFocalPointChange={onChange}
							onImageChange={onImageChange}
							options={options}
							isResponsive={isResponsive}
							onIsBusyChange={onIsBusyChange}
						/>
					</div>
				)}

				{(!isResponsive || activeTabId === "preview") && (
					<div className={styles.previewSectionContainer}>
						<FocalPointPreviewSection
							isResponsive={isResponsive}
							uri={uri}
							focalPoint={value}
						/>
					</div>
				)}
			</div>
		</div>
	);
};
FocalPointDialogContent.displayName = "FocalPointDialogContent";

type TabId = "editor" | "preview";

const tabsData: readonly TabsNavigationItemData<TabId>[] = [
	{
		text: localize("_SetFocalPoint"),
		value: "editor"
	},
	{
		text: localize("_ThumbnailPreview"),
		value: "preview"
	}
];